<script lang="ts">
export default { name: 'LayoutFooter', inheritAttrs: false }
</script>

<script lang="ts" setup>
import { ref, inject, onMounted, onBeforeUnmount } from 'vue'
import { LayoutDataKey } from './use-layout-data'

const layout = inject(LayoutDataKey)

/** フッター要素 */
const footerEl = ref<HTMLElement | null>(null)

/** ResizeObserver */
const resizeObserver = ref<ResizeObserver | null>(null)

/** IntersectionObserver */
const intersectionObserver = ref<IntersectionObserver | null>(null)

onMounted(() => {
  if (footerEl.value && layout) {
    resizeObserver.value = new ResizeObserver(entries => {
      for (const entry of entries) {
        layout.footer.height = entry.contentRect.height
      }
    })
    resizeObserver.value.observe(footerEl.value)

    intersectionObserver.value = new IntersectionObserver(
      entries => {
        for (const entry of entries) {
          layout.footer.offset = entry.intersectionRect.height
        }
      },
      { threshold: [...Array(100 + 1).keys()].map(i => i / 100) },
    )
    intersectionObserver.value.observe(footerEl.value)
  }
})

onBeforeUnmount(() => {
  resizeObserver.value?.disconnect()
  intersectionObserver.value?.disconnect()
})
</script>

<template>
  <footer ref="footerEl" class="w-full absolute bottom-0">
    <slot />
  </footer>
</template>
